import React from 'react'
import classes from './Motivation.module.sass'
import { Helmet } from 'react-helmet-async'
import { List } from './components/list/List'
import { Button } from '../../../common/components/button/Button'
import { Modal } from '../../../common/components/modal/Modal'
import { Form } from './components/form/Form'
import { Details } from './components/details/Details'
import Search from '../../../common/components/listControl/search/Search'
import { useMotivation } from './hooks/useMotivation'

export const Motivation = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    edit,
    startEdit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading,
    searchQuery,
    handleSearch,
    clearSearch,
    startDuplicate,
  } = useMotivation()

  return (
    <div className={classes.container}>
      <Helmet>
        <title>Мотивация</title>
        <meta name="description" content="Управление мотивацией исполнителей" />
      </Helmet>
      <div className={classes.titleWithButtons}>
        <div className={classes.header}>Мотивация</div>
        <Button onClick={startCreate} text="Создать" />
      </div>

      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по названию или описанию"
        />
      </div>

      <List
        startEdit={startEdit}
        list={list}
        showDetails={showDetails}
        loading={loading}
        startDuplicate={startDuplicate}
      />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
        />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>
    </div>
  )
}
